// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pst-viewport[data-v-5a25fc0a]{display:block;height:auto;width:100%;min-height:400px}.hidden[data-v-5a25fc0a]{display:none}.container[data-v-5a25fc0a]{max-width:1024px!important}@media screen and (max-width:770px){#pst-viewport[data-v-5a25fc0a]{display:block;height:auto;width:100%;min-height:200px}}", ""]);
// Exports
module.exports = exports;
